export class SpaceAvailabilityRequestRecord {
	dates: string[] | undefined;
	productCode: string | undefined;
	placementCode: string | undefined;
	columns: number | undefined;
	depthMM: number | undefined;
	moduleCode: string | undefined;
}
